import { Icon, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import { type OrganizationModel } from "@package/ui-gql/index-data-access";
import { useOrganizationState } from "../../context/context-organization";

type OrganizationSelectProps = {
  onChange?: (org: OrganizationModel) => void;
};

export function OrganizationSelect({ onChange }: OrganizationSelectProps) {
  const {
    loading,
    organizations,
    setSelectedOrganization,
    selectedOrganization,
  } = useOrganizationState();

  return (
    <Select<OrganizationModel>
      activeItem={organizations.find(
        (org) => org.orgId === selectedOrganization?.orgId,
      )}
      items={organizations}
      itemPredicate={(query, org) =>
        org?.name?.toLocaleLowerCase()?.includes(query.toLocaleLowerCase()) ??
        false
      }
      itemRenderer={(org, { handleClick, handleFocus, modifiers }) => (
        <MenuItem
          active={modifiers.active}
          disabled={modifiers.disabled}
          key={org.orgId}
          onClick={handleClick}
          onFocus={handleFocus}
          roleStructure="listoption"
          text={org.name}
        />
      )}
      filterable
      noResults={
        <MenuItem
          disabled={true}
          text={loading === "pending" ? "Loading..." : "No Organizations"}
          roleStructure="listoption"
        />
      }
      onItemSelect={(org) => {
        setSelectedOrganization(org);
        onChange?.(org);
      }}
      popoverProps={{
        className: "m-h-80",
        minimal: true,
      }}
    >
      <MenuItem
        text={
          loading === "pending"
            ? "Loading..."
            : (selectedOrganization?.name ?? "Select Organization")
        }
        icon="office"
        intent="primary"
        selected
        disabled={loading !== "succeeded"}
        labelElement={<Icon icon="caret-down" />}
      />
    </Select>
  );
}
